/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// tanstack query
import { useMutation } from '@tanstack/react-query';

// api
import { apiClient } from '@lib/api-client';

// types
import { TMutationConfig } from '@lib/react-query';

/* -------------------------------------------------------------------------- */
/*                                     Type                                   */
/* -------------------------------------------------------------------------- */
type TUseMintProductionOptions = {
	mutationConfig?: TMutationConfig<typeof mintProduction>;
};

/* -------------------------------------------------------------------------- */
/*                                     Api                                    */
/* -------------------------------------------------------------------------- */
export const mintProduction = ({
	project,
	productions,
}: {
	project: string | string[];
	productions: string[];
}) => {
	return apiClient.post(`/aco2_tokens`, {
		project,
		productions,
	});
};

/* -------------------------------------------------------------------------- */
/*                                     Hooks                                  */
/* -------------------------------------------------------------------------- */
export const useMintProduction = ({
	mutationConfig,
}: TUseMintProductionOptions = {}) => {
	return useMutation({
		...mutationConfig,
		mutationFn: mintProduction,
	});
};
